import { useTranslation } from "react-i18next";
import badgeStyles from "../../components/HalalStatusBadge/HalalStatusBadge.module.css";
import screenerStyles from "../StockScreener/stockScreener.module.css";

/**
 * A fund or rulebook verdict. Only the four known values get a verdict
 * colour; UNQUALIFIED and anything unknown take the neutral badge, because
 * a declined answer in a verdict colour reads as a conclusion.
 */
const TONE: Record<string, string> = {
  HALAL: badgeStyles.halal,
  DOUBTFUL: badgeStyles.doubtful,
  "NOT HALAL": badgeStyles.notHalal,
};

/** `compact` = the stock screener's dense table pill size. */
export const EtfVerdictBadge = ({
  status,
  compact = false,
}: {
  status: string | null;
  compact?: boolean;
}) => {
  const { t } = useTranslation();
  if (!status) return <span className={badgeStyles.empty}>—</span>;

  const p = "pages.etfScreener.verdict.";
  const label =
    status === "HALAL"
      ? t(`${p}halal`)
      : status === "DOUBTFUL"
        ? t(`${p}doubtful`)
        : status === "NOT HALAL"
          ? t(`${p}notHalal`)
          : status === "UNQUALIFIED"
            ? t(`${p}notRated`)
            : status;
  // Same pill shape and casing as the verdicts; only the colour is neutral.
  const tone = TONE[status] ?? badgeStyles.unknown;
  const size = compact ? screenerStyles.statusCompact : "";
  return (
    <span className={`${badgeStyles.badge} ${tone} ${size}`} title={label}>
      {label}
    </span>
  );
};
